import { useEffect, useState } from "react";
import axios from "axios";
import { getRouterContractv1 } from "utils/exchange";
import { useNetwork } from "wagmi";
import { getChainId } from "config/constants/exchange";
import { provider } from "utils/wagmi";
import { USDW } from "config/constants/tokens";


export default function useTokenPrice() {
  const { chain } = useNetwork()
  const chainId = getChainId(chain);
  const [stats, setStats] = useState({
    tokenprice: 0
  });

  useEffect(() => {

    async function fetchTokenPrice() {
      try {

        const routerContract = getRouterContractv1(chainId, provider(chainId))

        let tokenprice = await routerContract.getPrice(USDW[chainId].address);

        setStats(prev => ({
          ...prev,
          tokenprice: Number(parseFloat(tokenprice.toString()) / Math.pow(10, 18))
        }));

      } catch (err) {
        console.error("Token price fetch error:", err.message);
      }
    }

    fetchTokenPrice();

  }, [chainId]);

  return stats;
}